import React, {useState} from "react";
import schoolInfo_styles from './SchoolInfo.module.css';
import styled from 'styled-components';
import YesCheckmark from '../resources/checkmark-yes.svg';
import NoCheckmark from '../resources/checkmark-no.svg';
import NoAnswer from '../resources/no-answer-checkmark1.png';
import YesCheckmarkGrey from '../resources/checkmark-yes-grey.svg';
import NoCheckmarkGrey from '../resources/checkmark-no-grey.svg';
import NoAnswerGrey from '../resources/no-answer-checkmark-grey1.png';
import DontKnowGrey from '../resources/dont-know-grey.svg';
import DontKnow from '../resources/dont-know.svg';
import HandCuffs from "../resources/Prison.png";
import SliderComponent from "./SliderComp";
import QuestionBox from "../components/QuestionBox";
import SliderComp from "./SliderComp";
const FlexBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 20px;
`;

const SchoolInfo_QA = (props) => (
    <FlexBox>
        <div className={schoolInfo_styles.title}>
            {/* {props.question} */}
            <QuestionBox color={(props.showUnanswered && props.answer === 999 && props.arrested === 999) ? 'red' : 'black'} question={props.question} index={props.index}></QuestionBox>
        </div>
        <div className={schoolInfo_styles.iconsBox}>
            <div onClick={()=> props.onAnswer(1)}>
                <img src={props.answer == 1 ? YesCheckmark : YesCheckmarkGrey} className={schoolInfo_styles.icon} />
                <div style={{textAlign: 'center'}}>Yes</div>
            </div>
            <div onClick={()=> props.onAnswer(0)}>
                <img src={props.answer == 0 ? NoCheckmark : NoCheckmarkGrey} className={schoolInfo_styles.icon} />
                <div style={{textAlign: 'center'}}>No</div>
            </div>
            <div onClick={()=> props.onAnswer(98)}>
                <img src={props.answer == 98 ? NoAnswer : NoAnswerGrey} className={schoolInfo_styles.icon} />
                <div style={{textAlign: 'left', marginLeft: '-30px'}}>I do not wish to answer</div>
            </div>
        </div>
    </FlexBox>
)

const SchoolInfo = (props) => {
    const adultQuestions = [
        "In the past 30 days, how many times have you been arrested?",
        "Would you know where to go near you to see a health care professional regarding a drug or alcohol problem?",
        "Are you on parole or probation?",
        "Would you know where to go near you to see a healthcare professional regarding HIV/AIDS or other sexually transmitted health issues?"
    ]
    const youthQuestions = ["Have you ever been suspended from school for drug or alcohol use?",
        "In the past 30 days, how many times have you been arrested?",
        "Is there a doctor's office, health center, or other similar place that you usually go to when you are sick?",
        "Are you on parole or probation?"]
    const [adultAnswers, setAdultAnswers] = useState([999, 999, 999])
    const [youthAnswers, setYouthAnswers] = useState([999, 999, 999])
    const [arrested, setArrested] = useState(999)

    // const [enableNext, setEnableNext] = React.useState(false);

    React.useEffect(() => {
        if ((props.age > 17 && adultAnswers[0] != 999 && adultAnswers[1] != 999 && arrested != 999) || (props.age < 18 && youthAnswers[0] != 999 && youthAnswers[1] != 999 && youthAnswers[2] != 999 && arrested != 999)) {
            let data = {
                SCH_SUSP_ALDRG: props.age > 17 ? 98 : youthAnswers[0],
                NumberOfTimesArrestedValue: arrested,
                USUAL_DOC: props.age > 17 ? 98 : youthAnswers[1],
                KNOW_SA: props.age < 18 ? 98 : adultAnswers[0],
                ParoleOrProbation: props.age < 18 ? youthAnswers[2] : adultAnswers[1],
                KNOW_HIV: props.age < 18 ? 98 : adultAnswers[2]
            }
            props.setSchoolInfoData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [adultAnswers, youthAnswers, arrested]);
  
    const onAdultAnswerChange = (answer, index) => {
        let answers_changed = [...adultAnswers];
        answers_changed[index] = answer;
        setAdultAnswers(answers_changed);
        // console.log(answers);
    }

    const onYouthAnswerChange = (answer, index) => {
        let answers_changed = [...youthAnswers];
        answers_changed[index] = answer;
        setYouthAnswers(answers_changed);
    }

    // console.log("arrested", arrested);
    // console.log("adultAnswers", adultAnswers);
    // console.log("youthAnswers", youthAnswers);
    // console.log("props", props);

    return (
        <div className={schoolInfo_styles.container}>
            {props.age < 18 ?
            <>
                <SchoolInfo_QA showUnanswered={props.showUnanswered} question={youthQuestions[0]} index={1} answer={youthAnswers[0]} onAnswer={answer => onYouthAnswerChange(answer, 0)}></SchoolInfo_QA>
                <FlexBox>
                    <div className={schoolInfo_styles.title}>
                    <QuestionBox question={youthQuestions[1]} index={2}></QuestionBox>
                    </div>
                    <div>
                        <SliderComp min={0} icon={HandCuffs} handleAnswerChange={(value)=>setArrested(value)} answer={(arrested === 999 || arrested === undefined) ? undefined : (arrested > 96 ? 0 : arrested)}></SliderComp>
                    </div>
                    <div className={schoolInfo_styles.doNotWishDiv}>
                        <div style={{textAlign: "center"}} onClick={()=> setArrested(97)}>
                            <img src={arrested === 97 ? NoAnswer : NoAnswerGrey} className={schoolInfo_styles.icon} />
                            <div>I do not wish to answer</div>
                        </div>
                        
                        <div style={{textAlign: "center"}} onClick={()=> setArrested(98)}>
                            <img src={arrested === 98 ? DontKnow : DontKnowGrey} className={schoolInfo_styles.icon} />
                            <div>I do not know</div>
                        </div>
                    </div>
                </FlexBox>
                <SchoolInfo_QA showUnanswered={props.showUnanswered} question={youthQuestions[2]} index={3} answer={youthAnswers[1]} onAnswer={answer => onYouthAnswerChange(answer, 1)}></SchoolInfo_QA>
                <SchoolInfo_QA showUnanswered={props.showUnanswered} question={youthQuestions[3]} index={4} answer={youthAnswers[2]} onAnswer={answer => onYouthAnswerChange(answer, 2)}></SchoolInfo_QA>
            </> : null}
            {props.age > 17 ?
            <>
                <FlexBox>
                    <div className={schoolInfo_styles.title}>
                    <QuestionBox question={adultQuestions[0]} index={1}></QuestionBox>
                    </div>
                    <div>
                        <SliderComp min={0} icon={HandCuffs} handleAnswerChange={(value)=>setArrested(value)} answer={(arrested === 999 || arrested === undefined) ? undefined : (arrested > 96 ? 0 : arrested)}></SliderComp>
                    </div>
                    <div className={schoolInfo_styles.doNotWishDiv}>
                        <div style={{textAlign: "center"}} onClick={()=> setArrested(97)}>
                            <img src={arrested === 97 ? NoAnswer : NoAnswerGrey} className={schoolInfo_styles.icon} />
                            <div>I do not wish to answer</div>
                        </div>
                        
                        <div style={{textAlign: "center"}} onClick={()=> setArrested(98)}>
                            <img src={arrested === 98 ? DontKnow : DontKnowGrey} className={schoolInfo_styles.icon} />
                            <div>I do not know</div>
                        </div>
                    </div>
                </FlexBox>
                <SchoolInfo_QA showUnanswered={props.showUnanswered} question={adultQuestions[1]} index={2} answer={adultAnswers[0]} onAnswer={answer => onAdultAnswerChange(answer, 0)}></SchoolInfo_QA>
                
                <SchoolInfo_QA showUnanswered={props.showUnanswered} question={adultQuestions[2]} index={3} answer={adultAnswers[1]} onAnswer={answer => onAdultAnswerChange(answer, 1)}></SchoolInfo_QA>
                <SchoolInfo_QA showUnanswered={props.showUnanswered} question={adultQuestions[3]} index={4} answer={adultAnswers[2]} onAnswer={answer => onAdultAnswerChange(answer, 2)}></SchoolInfo_QA>

            </> : null}
        </div>
    );
}

export default SchoolInfo;